import { companyProfileEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyProfileHandler } from "@/services/shared";
import type {
    ApiCompanyProfileType,
    CompanyProfileType,
    UpdateCompanyProfileRequestType,
} from "@/types";

export const updateCompanyProfileHandler = async ({
    companyName,
    name,
    phone,
}: UpdateCompanyProfileRequestType): Promise<{
    message: string,
    profile: CompanyProfileType,
}> => {
    const payload: Record<string, string | undefined> = {
        company_name: companyName, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
        name: name,
        phone: phone,
    };

    const response = await axiosClient.put<ApiCompanyProfileType & { message?: string }>(
        companyProfileEndpoints.base,
        payload,
    );

    return {
        message: response.data.message ?? "",
        profile: transformApiCompanyProfileHandler(response.data),
    };
};
